// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/pen.js';

import { paths } from '../generated/pen';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('pen', Original, paths);
